export default "__VITE_ASSET__2c6b34b4__"